import './bootstrap';

import 'flowbite/dist/flowbite.js'

import 'lity';

import './hint-css.js';

import 'sortable-tablesort/sortable.min.js'

import { createModal } from './modal';
window.createModal = createModal;

import './app_settings'; // Simply ensures `index.js` runs
import './bill_of_materials'; // Simply ensures `index.js` runs

var XLSX = require("xlsx");
window.XLSX = XLSX;



// import { fetchAppSettings } from './app_settings/api';
// window.fetchAppSettings = fetchAppSettings;
//
// import { renderAppSettings } from './app_settings/render';
// window.renderAppSettings = renderAppSettings;
//
// import { showAppSettingsModal } from './app_settings/index';
// window.showAppSettingsModal = showAppSettingsModal;
//
// document.addEventListener('DOMContentLoaded', () => {
//     const appSettingLink = document.getElementById('app_setting_link');
//     if (appSettingLink) {
//         appSettingLink.addEventListener('click', async () => {
//             if (typeof showAppSettingsModal === 'function') {
//                 await showAppSettingsModal();
//             } else {
//                 console.error('showAppSettingsModal is not a function!');
//             }
//         });
//     }
// });

document.body.addEventListener('focus', function(event) {
    if (event.target.tagName.toLowerCase() === 'input') {
        event.target.select();
    }
}, true);

var themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
var themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

// Change the icons inside the button based on previous settings
if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    themeToggleLightIcon.classList.remove('hidden');
} else {
    themeToggleDarkIcon.classList.remove('hidden');
}

var themeToggleBtn = document.getElementById('theme-toggle');

themeToggleBtn.addEventListener('click', function () {

    // toggle icons inside button
    themeToggleDarkIcon.classList.toggle('hidden');
    themeToggleLightIcon.classList.toggle('hidden');

    // if set via local storage previously
    if (localStorage.getItem('color-theme')) {
        if (localStorage.getItem('color-theme') === 'light') {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        }

        // if NOT set via local storage previously
    } else {
        if (document.documentElement.classList.contains('dark')) {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        } else {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        }
    }

});



/**
 *  disable submit button after form submit
 */
// Get all the forms on the page
const forms = document.getElementsByTagName('form');
// console.log(forms)
// Add an event listener to the submit event of each form
for (let i = 0; i < forms.length; i++) {
    forms[i].addEventListener('submit', function(event) {
        // Check if the form can be submitted
        if (this.hasAttribute('data-submitted')) {
            console.log('Form is already submitted');
            // Form has already been submitted, prevent further submissions
            event.preventDefault();
        } else {
            console.log('Form is being submitted')
            // Set an attribute to mark the form as submitted
            this.setAttribute('data-submitted', 'true');

            // Get the submit button of the form
            const submitButton = this.querySelector('button[type="submit"], input[type="submit"]');

            // Add the opacity-50 class to the submit button
            if (submitButton) {
                submitButton.classList.add('!opacity-50');
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    // Get all elements with the class 'autoComplete'
    var modals = document.getElementsByClassName('autoComplete');

    // When the user clicks anywhere outside the modals, close them
    window.onclick = function(event) {
        // Convert the collection to an array to use array methods
        var modalsArray = Array.from(modals);

        // Check if any modal is open and if the click is outside of it
        modalsArray.forEach(function(modal) {
            console.log(modal)
            if (modal.contains(event.target) || event.target.classList.contains('autoCompleteIgnore')) {
                return; // Click is inside the modal, do nothing
            }

            // Click is outside the modal, remove it
            modal.remove();

            // remove "autoCompleteIgnore" class from all elements in order_items
            removeClassRecursively($('#order_items'), 'autoCompleteIgnore')

        });
    }
});
function removeClassRecursively(element, className) {
    element.removeClass(className); // Remove the class from the current element

    // Recursively remove the class from children elements
    element.children().each(function() {
        removeClassRecursively($(this), className);
    });
}

